var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          class: [
            "form-item",
            _vm.item.data.inputtype,
            _vm.item.data.htmloptions,
            {
              "is-invalid": _vm.isInvalid,
              "is-filled": _vm.internalValue != "",
            },
          ],
        },
        [
          _vm.item.data.description != ""
            ? _c("span", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.item.data.description)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.data.inputtype === "textarea"
            ? _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.internalValue,
                        expression: "internalValue",
                      },
                    ],
                    attrs: {
                      id: _vm.item.data.id,
                      name: _vm.item.data.id,
                      maxlength: _vm.item.data.inputmaxlength,
                      readonly: _vm.item.data.readonly,
                      disabled: _vm.item.data.disabled,
                      placeholder: _vm.item.data.placeholder
                        ? _vm.item.data.placeholder
                        : " ",
                    },
                    domProps: { value: _vm.internalValue },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.internalValue = $event.target.value
                        },
                        function ($event) {
                          return _vm.updateFormValue(
                            _vm.item.data.uniqlabel,
                            $event.target.value
                          )
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c("Label", {
                    attrs: {
                      item: _vm.item,
                      "is-invalid": _vm.isInvalid,
                      "error-message": _vm.errorMessage,
                    },
                  }),
                ],
                1
              )
            : _vm.item.data.inputtype === "date"
            ? _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("v-date-picker", {
                    attrs: {
                      readonly: "readonly",
                      popover: {
                        visibility: "focus",
                      },
                      locale: _vm.locale,
                    },
                    on: {
                      input: (date) =>
                        _vm.updateFormValue(_vm.item.data.uniqlabel, date),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "template-root" },
                                [
                                  _c(
                                    "input",
                                    _vm._g(
                                      {
                                        attrs: {
                                          type: "hidden",
                                          placeholder:
                                            _vm.item.data.placeholder,
                                          readonly: "readonly",
                                          name: _vm.item.data.id,
                                        },
                                        domProps: {
                                          value: _vm.dateFormatted(inputValue),
                                        },
                                      },
                                      inputEvents
                                    )
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "input",
                                    _vm._g(
                                      {
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            _vm.item.data.placeholder,
                                          readonly: "readonly",
                                        },
                                        domProps: { value: inputValue },
                                      },
                                      inputEvents
                                    )
                                  ),
                                  _vm._v(" "),
                                  _c("Label", {
                                    attrs: {
                                      item: _vm.item,
                                      "is-invalid": _vm.isInvalid,
                                      "error-message": _vm.errorMessage,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2962689274
                    ),
                    model: {
                      value: _vm.internalValue,
                      callback: function ($$v) {
                        _vm.internalValue = $$v
                      },
                      expression: "internalValue",
                    },
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "icon-form-datepicker" }),
                ],
                1
              )
            : _vm.item.data.inputtype === "time"
            ? _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("v-date-picker", {
                    attrs: {
                      mode: "time",
                      is24hr: true,
                      "minute-increment": 5,
                      locale: _vm.locale,
                      readonly: "readonly",
                      popover: {
                        visibility: "focus",
                      },
                    },
                    on: {
                      input: (date) =>
                        _vm.updateFormValue(_vm.item.data.uniqlabel, date),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "template-root" },
                                [
                                  _c(
                                    "input",
                                    _vm._g(
                                      {
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            _vm.item.data.placeholder,
                                          readonly: "readonly",
                                          name: _vm.item.data.id,
                                        },
                                        domProps: { value: inputValue },
                                      },
                                      inputEvents
                                    )
                                  ),
                                  _vm._v(" "),
                                  _c("Label", {
                                    attrs: {
                                      item: _vm.item,
                                      "is-invalid": _vm.isInvalid,
                                      "error-message": _vm.errorMessage,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      435450121
                    ),
                    model: {
                      value: _vm.internalValue,
                      callback: function ($$v) {
                        _vm.internalValue = $$v
                      },
                      expression: "internalValue",
                    },
                  }),
                ],
                1
              )
            : _vm.item.data.inputtype === "number"
            ? _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _vm.item.data.inputtype === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder,
                          min: _vm.item.data.inputnumbermin,
                          max: _vm.item.data.inputnumbermax,
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.internalValue)
                            ? _vm._i(_vm.internalValue, null) > -1
                            : _vm.internalValue,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                          change: function ($event) {
                            var $$a = _vm.internalValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.internalValue = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.internalValue = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.internalValue = $$c
                            }
                          },
                        },
                      })
                    : _vm.item.data.inputtype === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder,
                          min: _vm.item.data.inputnumbermin,
                          max: _vm.item.data.inputnumbermax,
                          type: "radio",
                        },
                        domProps: { checked: _vm._q(_vm.internalValue, null) },
                        on: {
                          input: function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                          change: function ($event) {
                            _vm.internalValue = null
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder,
                          min: _vm.item.data.inputnumbermin,
                          max: _vm.item.data.inputnumbermax,
                          type: _vm.item.data.inputtype,
                        },
                        domProps: { value: _vm.internalValue },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.internalValue = $event.target.value
                            },
                            function ($event) {
                              return _vm.updateFormValue(
                                _vm.item.data.uniqlabel,
                                $event.target.value
                              )
                            },
                          ],
                        },
                      }),
                  _vm._v(" "),
                  _c("Label", {
                    attrs: {
                      item: _vm.item,
                      "is-invalid": _vm.isInvalid,
                      "error-message": _vm.errorMessage,
                    },
                  }),
                ],
                1
              )
            : _vm.item.data.inputtype === "color"
            ? _c("div", { staticClass: "input-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-grow-1 mr-2" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.color,
                              expression: "color",
                            },
                          ],
                          attrs: {
                            readonly: "",
                            placeholder: _vm.item.data.placeholder,
                          },
                          domProps: { value: _vm.color },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.color = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("Label", {
                          attrs: {
                            item: _vm.item,
                            "is-invalid": _vm.isInvalid,
                            "error-message": _vm.errorMessage,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("vue-swatches", {
                      attrs: {
                        "popover-x": "right",
                        "show-fallback": "",
                        "fallback-input-type": "color",
                        inline: false,
                      },
                      model: {
                        value: _vm.color,
                        callback: function ($$v) {
                          _vm.color = $$v
                        },
                        expression: "color",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm.item.data.inputtype === "range"
            ? _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("Label", {
                    attrs: {
                      item: _vm.item,
                      "error-message": _vm.errorMessage,
                      "is-invalid": _vm.isInvalid,
                    },
                  }),
                  _vm._v(" "),
                  _vm.item.data.inputtype === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          readonly: _vm.item.data.readonly,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder,
                          min: _vm.item.data.inputslidermin,
                          max: _vm.item.data.inputslidermax,
                          step: _vm.item.data.inputslidersteps,
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.internalValue)
                            ? _vm._i(_vm.internalValue, null) > -1
                            : _vm.internalValue,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                          change: function ($event) {
                            var $$a = _vm.internalValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.internalValue = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.internalValue = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.internalValue = $$c
                            }
                          },
                        },
                      })
                    : _vm.item.data.inputtype === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          readonly: _vm.item.data.readonly,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder,
                          min: _vm.item.data.inputslidermin,
                          max: _vm.item.data.inputslidermax,
                          step: _vm.item.data.inputslidersteps,
                          type: "radio",
                        },
                        domProps: { checked: _vm._q(_vm.internalValue, null) },
                        on: {
                          input: function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                          change: function ($event) {
                            _vm.internalValue = null
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          readonly: _vm.item.data.readonly,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder,
                          min: _vm.item.data.inputslidermin,
                          max: _vm.item.data.inputslidermax,
                          step: _vm.item.data.inputslidersteps,
                          type: _vm.item.data.inputtype,
                        },
                        domProps: { value: _vm.internalValue },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.internalValue = $event.target.value
                            },
                            function ($event) {
                              return _vm.updateFormValue(
                                _vm.item.data.uniqlabel,
                                $event.target.value
                              )
                            },
                          ],
                        },
                      }),
                ],
                1
              )
            : _vm.item.data.inputtype === "hidden"
            ? _c("div", { staticClass: "input-wrapper" }, [
                _vm.item.data.inputtype === "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.internalValue,
                          expression: "internalValue",
                        },
                      ],
                      attrs: {
                        id: _vm.item.data.id,
                        name: _vm.item.data.id,
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.internalValue)
                          ? _vm._i(_vm.internalValue, null) > -1
                          : _vm.internalValue,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateFormValue(
                            _vm.item.data.uniqlabel,
                            $event.target.value
                          )
                        },
                        change: function ($event) {
                          var $$a = _vm.internalValue,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.internalValue = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.internalValue = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.internalValue = $$c
                          }
                        },
                      },
                    })
                  : _vm.item.data.inputtype === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.internalValue,
                          expression: "internalValue",
                        },
                      ],
                      attrs: {
                        id: _vm.item.data.id,
                        name: _vm.item.data.id,
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.internalValue, null) },
                      on: {
                        input: function ($event) {
                          return _vm.updateFormValue(
                            _vm.item.data.uniqlabel,
                            $event.target.value
                          )
                        },
                        change: function ($event) {
                          _vm.internalValue = null
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.internalValue,
                          expression: "internalValue",
                        },
                      ],
                      attrs: {
                        id: _vm.item.data.id,
                        name: _vm.item.data.id,
                        type: _vm.item.data.inputtype,
                      },
                      domProps: { value: _vm.internalValue },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.internalValue = $event.target.value
                          },
                          function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                        ],
                      },
                    }),
              ])
            : _vm.item.data.inputtype === "password"
            ? _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _vm.passwordFieldType === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder
                            ? _vm.item.data.placeholder
                            : " ",
                          maxlength:
                            _vm.item.data.inputtype === "text"
                              ? _vm.item.data.inputmaxlength
                              : false,
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.internalValue)
                            ? _vm._i(_vm.internalValue, null) > -1
                            : _vm.internalValue,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                          change: function ($event) {
                            var $$a = _vm.internalValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.internalValue = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.internalValue = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.internalValue = $$c
                            }
                          },
                        },
                      })
                    : _vm.passwordFieldType === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder
                            ? _vm.item.data.placeholder
                            : " ",
                          maxlength:
                            _vm.item.data.inputtype === "text"
                              ? _vm.item.data.inputmaxlength
                              : false,
                          type: "radio",
                        },
                        domProps: { checked: _vm._q(_vm.internalValue, null) },
                        on: {
                          input: function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                          change: function ($event) {
                            _vm.internalValue = null
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          name: _vm.item.data.id,
                          placeholder: _vm.item.data.placeholder
                            ? _vm.item.data.placeholder
                            : " ",
                          maxlength:
                            _vm.item.data.inputtype === "text"
                              ? _vm.item.data.inputmaxlength
                              : false,
                          type: _vm.passwordFieldType,
                        },
                        domProps: { value: _vm.internalValue },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.internalValue = $event.target.value
                            },
                            function ($event) {
                              return _vm.updateFormValue(
                                _vm.item.data.uniqlabel,
                                $event.target.value
                              )
                            },
                          ],
                        },
                      }),
                  _vm._v(" "),
                  _c("Label", {
                    attrs: {
                      item: _vm.item,
                      "is-invalid": _vm.isInvalid,
                      "error-message": _vm.errorMessage,
                    },
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "password-icon",
                    class: [
                      _vm.showPassword ? "icon-form-show" : "icon-form-hide",
                    ],
                    on: { click: _vm.toggleShowPassword },
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _vm.item.data.inputtype === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          name: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          placeholder: _vm.item.data.placeholder
                            ? _vm.item.data.placeholder
                            : " ",
                          maxlength:
                            _vm.item.data.inputtype === "text"
                              ? _vm.item.data.inputmaxlength
                              : false,
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.internalValue)
                            ? _vm._i(_vm.internalValue, null) > -1
                            : _vm.internalValue,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                          change: function ($event) {
                            var $$a = _vm.internalValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.internalValue = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.internalValue = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.internalValue = $$c
                            }
                          },
                        },
                      })
                    : _vm.item.data.inputtype === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          name: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          placeholder: _vm.item.data.placeholder
                            ? _vm.item.data.placeholder
                            : " ",
                          maxlength:
                            _vm.item.data.inputtype === "text"
                              ? _vm.item.data.inputmaxlength
                              : false,
                          type: "radio",
                        },
                        domProps: { checked: _vm._q(_vm.internalValue, null) },
                        on: {
                          input: function ($event) {
                            return _vm.updateFormValue(
                              _vm.item.data.uniqlabel,
                              $event.target.value
                            )
                          },
                          change: function ($event) {
                            _vm.internalValue = null
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.internalValue,
                            expression: "internalValue",
                          },
                        ],
                        attrs: {
                          id: _vm.item.data.id,
                          name: _vm.item.data.id,
                          disabled: _vm.item.data.disabled,
                          placeholder: _vm.item.data.placeholder
                            ? _vm.item.data.placeholder
                            : " ",
                          maxlength:
                            _vm.item.data.inputtype === "text"
                              ? _vm.item.data.inputmaxlength
                              : false,
                          type: _vm.item.data.inputtype,
                        },
                        domProps: { value: _vm.internalValue },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.internalValue = $event.target.value
                            },
                            function ($event) {
                              return _vm.updateFormValue(
                                _vm.item.data.uniqlabel,
                                $event.target.value
                              )
                            },
                          ],
                        },
                      }),
                  _vm._v(" "),
                  _c("Label", {
                    attrs: {
                      item: _vm.item,
                      "is-invalid": _vm.isInvalid,
                      "error-message": _vm.errorMessage,
                    },
                  }),
                ],
                1
              ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }